module.exports = "<div class=\"container\">\r\n  <h1 class=\"about\">Contact Us</h1>\r\n  <p>Coming Soon.</p>\r\n</div>"